module.exports = __webpack_public_path__ + "static/media/icon-modal-help.1b4739cd.svg";